import React from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <nav className="w-full">
      <div className="bg-blue-900 text-white py-2 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm">
          <div className="flex items-center space-x-4 mb-2 sm:mb-0">
            <div className="flex items-center space-x-1">
              <Mail size={14} />
              <span>info@dpjewellersballia.in</span>
            </div>
            <div className="flex items-center space-x-1">
              <Phone size={14} />
              <span> 089537 86652</span>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <a href="#" className="hover:text-[#60a5fa] transition-colors">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879v-6.99h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.99C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
              </svg>
            </a>
            <a href="#" className="hover:text-[#60a5fa] transition-colors">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a href="#" className="hover:text-[#60a5fa] transition-colors">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123 0 2.716-.012 3.056-.06 4.122-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06-2.716 0-3.056-.012-4.122-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808 0-2.429.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.315 4.159c-1.996 0-3.616 1.62-3.616 3.616 0 1.996 1.62 3.616 3.616 3.616 1.996 0 3.616-1.62 3.616-3.616 0-1.996-1.62-3.616-3.616-3.616zm0 9.032c-2.987 0-5.416-2.429-5.416-5.416 0-2.987 2.429-5.416 5.416-5.416 2.987 0 5.416 2.429 5.416 5.416 0 2.987-2.429 5.416-5.416 5.416zm7.846-9.575c0 .698-.566 1.264-1.264 1.264-.698 0-1.264-.566-1.264-1.264 0-.698.566-1.264 1.264-1.264.698 0 1.264.566 1.264 1.264z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <img 
                src="/logo.png" 
                alt="Royal Gems Logo" 
                className="h-16 md:h-20 w-auto object-contain py-1"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Home</a>
            <a href="/transformation" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Our Story</a>
              <div className="relative group">
                <button className="flex items-center text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">
                  Collections
                  <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                <div className="absolute left-0 mt-0 w-56 bg-white rounded-md shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">
                  <div className="py-2">
                    <a href="goldjwellery" className="block px-4 py-2 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb]">Gold Jewellery</a>
                    <a href="dimondjewellery" className="block px-4 py-2 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb]">Diamond Jewellery</a>
                    <a href="silver" className="block px-4 py-2 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb]">Silver Articles</a>
                    <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb]">Platinum</a>
                    <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb]">Gemstones</a>
                  </div>
                </div>
              </div>
               <a href="shop" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Shop</a>
               <a href="necklaces" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Necklaces</a>
              <a href="ring" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Ring</a>
              <a href="contact" className="text-gray-700 hover:text-[#2563eb] font-medium text-base py-3">Contact</a>
            </div>
            <div className="md:hidden">
              <button onClick={toggleMenu} className="text-gray-700 hover:text-[#2563eb] focus:outline-none">
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
          {isMenuOpen && (
            <div className="md:hidden pb-4 border-t border-gray-100">
              <div className="flex flex-col space-y-3 pt-4">
                <div className="relative">
                  <button className="w-full text-left flex justify-between items-center text-gray-700 hover:text-[#2563eb] font-medium py-2">
                    Collections
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className="pl-4 mt-2 space-y-2">
                    <a href="#" className="block text-gray-600 hover:text-[#2563eb] py-1">Gold Jewellery</a>
                    <a href="#" className="block text-gray-600 hover:text-[#2563eb] py-1">Diamond Jewellery</a>
                    <a href="#" className="block text-gray-600 hover:text-[#2563eb] py-1">Silver Articles</a>
                    <a href="#" className="block text-gray-600 hover:text-[#2563eb] py-1">Platinum</a>
                    <a href="#" className="block text-gray-600 hover:text-[#2563eb] py-1">Gemstones</a>
                  </div>
                </div>
                <a href="#" className="text-gray-700 hover:text-[#2563eb] font-medium py-2">Our Story</a>
                <a href="#" className="text-gray-700 hover:text-[#2563eb] font-medium py-2">Contact</a>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;